// Global packages and components
import { clsx } from 'clsx'
import { ProductExtrasCard } from '~/components'

// Types
import type { Dispatch, SetStateAction } from 'react'
import type { PurchaseModalExtra } from '~/hooks/usePurchaseModal'

interface Props {
  addOns: PurchaseModalExtra[]
  crossSells: PurchaseModalExtra[]
  totalStages: number
  currentStage: number
  setAddOns: Dispatch<SetStateAction<PurchaseModalExtra[]>>
  setCrossSells: Dispatch<SetStateAction<PurchaseModalExtra[]>>
}

// Main export
const HireExtras = ({
  addOns,
  crossSells,
  totalStages,
  currentStage,
  setAddOns,
  setCrossSells,
}: Props) => (
  <div className="scrollbar-brand relative max-h-[46vh] min-h-0 overflow-y-auto pr-2 transition-opacity md:max-h-[68vh] 2xl:max-h-[43rem]">
    <div
      className={clsx({
        hidden: currentStage !== 1,
      })}
    >
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-5 lg:grid-cols-3 xl:grid-cols-4">
        {totalStages == 1 && crossSells?.length > 0
          ? crossSells.map(e => (
              <ProductExtrasCard
                {...e}
                key={e?.stockCode}
                name={e?.title}
                setQuantity={raw => {
                  const trimmed = raw.trim()

                  // allow mid-typing empty string without committing to state
                  if (trimmed === '') return

                  const n = Number(trimmed)
                  if (!Number.isFinite(n)) return

                  setCrossSells(prev =>
                    prev.map(x =>
                      x.stockCode === e.stockCode ? { ...x, quantity: n } : x
                    )
                  )
                }}
              />
            ))
          : addOns.map(e => (
              <ProductExtrasCard
                {...e}
                key={e?.stockCode}
                name={e?.title}
                setQuantity={raw => {
                  const trimmed = raw.trim()

                  // allow mid-typing empty string without committing to state
                  if (trimmed === '') return

                  const n = Number(trimmed)
                  if (!Number.isFinite(n)) return

                  setAddOns(prev =>
                    prev.map(x =>
                      x.stockCode === e.stockCode ? { ...x, quantity: n } : x
                    )
                  )
                }}
              />
            ))}
      </div>
    </div>
    <div
      className={clsx({
        hidden: currentStage !== 2,
      })}
    >
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-5 lg:grid-cols-3 xl:grid-cols-4">
        {crossSells.map(e => (
          <ProductExtrasCard
            {...e}
            key={e?.stockCode}
            name={e?.title}
            setQuantity={raw => {
              const trimmed = raw.trim()

              // allow mid-typing empty string without committing to state
              if (trimmed === '') return

              const n = Number(trimmed)
              if (!Number.isFinite(n)) return

              setCrossSells(prev =>
                prev.map(x =>
                  x.stockCode === e.stockCode ? { ...x, quantity: n } : x
                )
              )
            }}
          />
        ))}
      </div>
    </div>
  </div>
)

export default HireExtras
